import { render, staticRenderFns } from "./salesPreferential.vue?vue&type=template&id=6989476b&scoped=true&"
import script from "./salesPreferential.vue?vue&type=script&lang=js&"
export * from "./salesPreferential.vue?vue&type=script&lang=js&"
import style0 from "./salesPreferential.vue?vue&type=style&index=0&id=6989476b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989476b",
  null
  
)

export default component.exports